export * from './lib/toast.module';

export { AccredibleToastService, ToastAction } from './lib/service/toast.service';
export { AccredibleToastRef } from './lib/toast-ref';
